import { useAuthentication } from 'root/src/client/v2/auth/hooks/useAuthentication';
export function useUserId() {
    const { authentication } = useAuthentication();
    return { userId: authentication === null || authentication === void 0 ? void 0 : authentication.userId };
}
